var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.editMode)?_c('practical-exam-update',{attrs:{"exam":_vm.exam,"loading":_vm.loading},on:{"on-close":_vm.onClose}}):_c('practical-exam-create',{attrs:{"loading":_vm.loading},on:{"on-close":_vm.onClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }